// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1UVQc","left":"InfoRow_left__1p8YH"};